// Free / personal email domains the onboarding wizard rejects before
// submitting to the backend. The backend maintains its own (authoritative)
// list; this one is UX only — it shows "Please use your business email"
// inline so users aren't bounced by the server after a round trip.
//
// Keep conceptually in sync with backend/internal/validation/email_domains.go.
export const FREE_EMAIL_DOMAINS: readonly string[] = [
  "gmail.com",
  "googlemail.com",
  "yahoo.com",
  "yahoo.co.uk",
  "yahoo.co.in",
  "ymail.com",
  "outlook.com",
  "hotmail.com",
  "live.com",
  "msn.com",
  "icloud.com",
  "me.com",
  "mac.com",
  "aol.com",
  "mail.com",
  "gmx.com",
  "gmx.net",
  "gmx.de",
  "gmx.us",
  "protonmail.com",
  "proton.me",
  "pm.me",
  "tutanota.com",
  "tuta.io",
  "fastmail.com",
  "hey.com",
  "zoho.com",
  "yandex.com",
  "yandex.ru",
  "qq.com",
  "163.com",
  "126.com",
];

const FREE_SET = new Set(FREE_EMAIL_DOMAINS.map((d) => d.toLowerCase()));

export function extractDomain(email: string): string | null {
  const at = email.lastIndexOf("@");
  if (at < 0) return null;
  const domain = email.slice(at + 1).trim().toLowerCase();
  return domain || null;
}

export function isFreeEmailDomain(email: string): boolean {
  const domain = extractDomain(email);
  if (!domain) return false;
  return FREE_SET.has(domain);
}
